import axios from "axios";
import { Global } from "../utils/general";
import headerRequest from "../utils/headers";

const API_URL = Global.url;

class SeguroService {
  declararAsegurados(data) {
    const ruta = `${API_URL}/seguro/declarar`;
    return axios
      .post(ruta, data, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  getHistorialTramites() {
    const ruta = `${API_URL}/seguro/historial`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  consultarConstancias(tramiteId_api) {
    const ruta = `${API_URL}/seguro/constancias/${tramiteId_api}`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }
}

export default new SeguroService();